var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var cookie = require('react-cookie');
var FBLoginButton = require('./fbLoginButton.jsx');

var SignUpBanner = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        this.$footer = $('#footer');
        this.$window = $(window);
        this.$signUpBanner = $('#signUpBanner');
        this.$heightChangeListenerWindow = $($('#heightChangeListener')[0].contentWindow);

        this.$heightChangeListenerWindow.on('resize.SignUpBanner', function(){
            this.positionSignUpBanner();
        }.bind(this));

        this.$window.on('scroll.SignUpBanner resize.SignUpBanner', function(event){
            this.positionSignUpBanner();
        }.bind(this));

        setTimeout(function(){
            this.positionSignUpBanner();
        }.bind(this), 0);
    },

    positionSignUpBanner: function(){
		if(!(this.$signUpBanner.is(':visible')
            && Foundation.MediaQuery.atLeast('large')
            && this.$footer.is(':visible')
            && $.find('.content > .loader').length === 0)){
            this.$signUpBanner.css('bottom', '');
			return;
		}

		var footerViewedHeight = this.$window.scrollTop() + this.$window.height() - this.$footer.offset().top;
		if(footerViewedHeight > 0) {
			this.$signUpBanner.css('bottom', footerViewedHeight);
		}else {
			this.$signUpBanner.css('bottom', '');
		}
	},

    handleClose: function(){
        $('#signUpBanner').hide();
        $('.outer-wrapper').removeClass('show-signUpBanner');
        this.$window.off('scroll.SignUpBanner resize.SignUpBanner');
        this.$heightChangeListenerWindow.off('resize.SignUpBanner');
        cookie.save('noSignUpBanner', true, {path: '/'});
    },

    handleClickTracking: function(e) {
        this.props.clickTracking('Click', 'Download App');
    },

    render: function(){
        return (
            <div id="signUpBanner">
                <div className="row">
                    <p>Sign up for MyGiHealth to <strong>track your symptoms</strong> and prepare for your gastroenterologist appointment.</p>
                    <p>
                        <FBLoginButton
                            label="Connect with Facebook"
                            authFacebook={this.props.authFacebook}
                            analyticsLabelSuffix="Sign Up Banner"
                            clickTracking={this.props.clickTracking} />
                        <a className="download-app" href="http://get.mygihealth.io/downloadtheapp" onClick={this.handleClickTracking}>
                            <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
                        </a>
                    </p>
                </div>
                <button className="close-button" type="button" onClick={this.handleClose}><span className="ion-ios-close-empty"></span></button>
            </div>
        );
    }
});

SignUpBanner.propTypes = {
    authFacebook: PropTypes.func.isRequired,
    clickTracking: PropTypes.func.isRequired
};

module.exports = SignUpBanner;



// WEBPACK FOOTER //
// ./src/common/routes/components/signUpBanner.jsx